import { Response } from 'request-dot-js'

import { LOGIN_OR_SIGNUP_PATH } from 'paths'
import { UserService } from 'api/clients/UserService'
import { getHistoryInstance } from 'hooks/useHistory'

let handlingExpiredSession = false

const getCurrentPath = () => {
  const history = getHistoryInstance()
  const { pathname, search } = history.location
  return `${pathname}${search}`
}

export const SessionService = {
  handleUnauthorized: (res: Response) => {
    const error = res.data.errors?.[0]

    const sessionExpired = res.data.error === 'Signature has expired'
    const invalidCredentials = error?.toLowerCase().startsWith('invalid login credentials')
    const loggedOut = error?.toLowerCase().startsWith('you need to sign in')

    if (sessionExpired || invalidCredentials || loggedOut) {
      if (handlingExpiredSession) return
      UserService.unsetAuthCookie()
      const historyInstance = getHistoryInstance()

      if (sessionExpired) {
        handlingExpiredSession = true
        historyInstance.push({
          pathname: LOGIN_OR_SIGNUP_PATH,
          search: `?redirect_to=${encodeURIComponent(getCurrentPath())}`,
        })
        setTimeout(() => {
          handlingExpiredSession = false
        }, 5000)
      } else {
        historyInstance.replace(LOGIN_OR_SIGNUP_PATH, { redirect_to: getCurrentPath() })
      }
    }
  },

  // Only used in tests - do not use in production code
  ...(process.env.NODE_ENV === 'test'
    ? {
        __resetHandlingExpiredSession: () => {
          handlingExpiredSession = false
        },
      }
    : {}),
}
